import { z } from "zod";

/**
 * Zod schema for SiteThemeConfig.
 */
export const siteThemeConfigSchema = z.object({
  primary: z.string().regex(/^#[0-9A-Fa-f]{6}$/, "Must be a valid hex color"),
  secondary: z.string().regex(/^#[0-9A-Fa-f]{6}$/, "Must be a valid hex color"),
  accent: z.string().regex(/^#[0-9A-Fa-f]{6}$/, "Must be a valid hex color"),
  background: z.string().regex(/^#[0-9A-Fa-f]{6}$/, "Must be a valid hex color"),
  text: z.string().regex(/^#[0-9A-Fa-f]{6}$/, "Must be a valid hex color"),
  cardRadius: z.string(),
  buttonRadius: z.string(),
  cardShadow: z.string(),
  gradientHeroStrong: z.string().optional(),
  gradientHeroSoft: z.string().optional(),
  gradientSurfaceBand: z.string().optional(),
});
